// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconMantle } from "../../../icons/full/build/icon-mantle.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const MantleIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconMantle.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  MantleIcon.displayName = 'MantleIcon';
}

export default MantleIcon;